import { useTheme } from "@emotion/react";
import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CenteredText from "components/CenteredText";
import Page from "components/Page";
import ReactPlayer from 'react-player/vimeo'

import AreaXLogo from "assets/images/areax_logo.svg"
import AreaXAssicura from "assets/images/assicura.png"
import { Link } from "react-router-dom";

const CosaAreaX = () => {
    const theme = useTheme();

    return (
        <Page bg={theme.palette.background.paper} syncNavCommand="AREAX_SLIDE" audioFile="/sounds/intro_areax.mp3" >
            <Stack spacing={2} sx={{
                display: 'flex',
                flex: 1
            }}>
                <CenteredText sx={{ marginBottom: '2rem' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <img src={AreaXLogo} alt="Area X" style={{ width: '50%' }} />
                    </Box>
                    <Typography variant="h5" sx={{
                        paddingInline: '1.1rem', lineHeight: '2rem', fontWeight: "bold",
                    }}>
                        Cos’è lo spazio Area X
                    </Typography>
                </CenteredText>
                <Box><Typography variant="body2" sx={{ paddingInline: '1.1rem', color: theme.palette.white.main }}>
                    Uno <b>spazio innovativo e immersivo</b> dedicato alla <b>cultura della protezione</b>.
                    Questa è <b>Area X</b>, un’iniziativa di <b>Intesa Sanpaolo Assicura</b> in cui la tecnologia
                    e il mondo della protezione si uniscono.
                </Typography></Box>
                <Box>
                    <ReactPlayer
                        controls={true}
                        url='https://vimeo.com/537708328'
                        width='100vw' height='17rem' />
                </Box>
                <Box>
                    <Typography variant="body2" sx={{ paddingInline: '1.1rem', color: theme.palette.white.main }}>
                        Entrando in Area X puoi sperimentare l’importanza della protezione mettendoti alla
                        prova con <b>esperienze immersive</b>. Potrai viaggiare all’interno
                        di una <b>navicella spaziale</b> nella sua fase di atterraggio sul <b>pianeta alieno</b>,
                        esplorandolo attraverso isole galleggianti. Con il punteggio ottenuto entrerai a far parte della classifica finale insieme a coloro che hanno vissuto la tua stessa esperienza virtuale.

                    </Typography>
                </Box>
                <Box>
                    <img src={AreaXAssicura} alt="Area X" style={{ width: '100%', marginTop: '1rem' }} />
                </Box>
                <Box>
                    <Typography variant="body2" sx={{ paddingInline: '1.1rem', color: theme.palette.white.main }}>
                        <b>Esperienza, protezione e futuro</b>: queste sono le nostre 3 parole chiave.

                    </Typography>
                </Box>
                <Box>
                    <Typography variant="body2" sx={{ paddingInline: '1.1rem', color: theme.palette.white.main }}>

                        <b>Prenota la tua esperienza virtuale gratuita su areax.info o con il mio aiuto!</b>
                    </Typography>
                </Box>
                <CenteredText style={{ marginBottom: '2rem' }}>
                    <Link to="/scopri_areax">
                        <Typography variant="h6"
                            color={theme.palette.white.main}
                            sx={{ textDecoration: 'underline' }}>
                            Torna a “Scopri Area X”
                        </Typography>
                    </Link>
                </CenteredText>
            </Stack>
        </Page >
    )
}

export default CosaAreaX